import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import _ from 'lodash';
import clsx from 'clsx';
import { Button } from 'react-bootstrap';
import CommonModal from '../../../../../SharedModules/Dialog/CommonModal';
import CommentIcon from '../../../../../assets/images/comment-dots.svg';
import CommentVisibleIcon from '../../../../../assets/images/commen-visible-icon.svg';
import CommentAndCorrespondenceComponent from '../../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import PDFExportPanel from '../../../../../SharedModules/pdfExport/PDFExportPanel';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';

import {
  QUARTER_FORMAT_ERROR,
  END_QTR_ERROR,
} from '../../../../../SharedModules/Errors/constantMessageData';
import TableGrid from '../../../../../SharedModules/Table/tableGrid';

import {
  saveExcludedNDCsDetailList,
  updateExcludedNDCsDetailList,
  setFilterAndSortForTable,
} from '../../store/actions';
import {
  autoFormateDate,
  checkActionAccessByRole,
} from '../../../../../SharedModules/utilities/utilities';

function TableGridComponent(props) {
  const {
    data,
    cellHead,
    onSelect,
    onCellValueChanged,
    singleClickEdit,
    gridHeight,
    rowSelection,
    childPopup,
    rowMultiSelectWithClick,
    tableHeader,
    filterIcon,
    setIsFilterNDCs,
    setIsFilterRightNDCs,
    setResetNDCsFilter,
    setResetRightNDCsFilter,
    resetNDCsFilter = false,
    resetRightNDCsFilter = false,
    tableName = false,
    historyIcon,
    handleViewHistoryPlan,
    actionIcon,
    addNDCsAction,
    addRowsView = false,
    fullScreenIcon,
    setFullScreenView,
    errorField,
    getQtrVal,
    validateQtr,
    fullScreenView,
    fullScreenViewTable,
    setEdit,
    fileName,
    setTotalResultCount,
    updateSetFieldErrors,
    setSuccessMessages,
    setLoading,
    onGridReady,
    setExcludedNDCs,
  } = props;

  const dispatch = useDispatch();
  const getNDCsList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.ndcsDetailList
  );
  const filterAndSort = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.filterAndSort
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const gridRef = React.useRef();
  const [gridApi, setGridApi] = useState(gridRef);
  const [columnApi, setColumnApi] = useState(null);
  const [curColumn, setCurColumn] = useState(null);
  const [selectRowData, setSelectRowData] = useState(null);
  const [columnList, setColumnList] = useState(null);
  const [columnAction, setColumnAction] = useState(false);
  const [pinnedColumnList, setPinnedColumnList] = useState(null);
  const [columnPinnedAction, setColumnPinnedAction] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [actionCellData, setActionCellData] = React.useState(null);
  const [allDeletedList, setAllDeletedList] = React.useState([]);
  const [gridParams, setGridParams] = React.useState(null);
  const [showComments, setShowComments] = useState(false);
  const [afterComment, setAfterComment] = useState(false);
  const [applyFilterAndSort, setApplyFilterANdSort] = useState(true);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  const saveQtrChanges = (allList, curtCol, value) => {
    const curtRow = allList?.data;
    const newList = allList?.parent?.allLeafChildren
      ? _.map(allList?.parent?.allLeafChildren, (val) => val.data)
      : [];
    const updateList = _.map(newList, (val) => {
      if (val.ndc === curtRow.ndc && val.listIndex === curtRow.listIndex) {
        val[curtCol] = value;
      }
      val.excludedNdcStatusCd = val.excludedNdcStatusCd;
      return val;
    });
    dispatch(updateExcludedNDCsDetailList(_.cloneDeep(updateList)));
  };

  const checkQtrValidation = (cellInfo, value) => {
    let indexOf = null;
    const newVal = value;
    const curtCol = cellInfo.column.colId;
    const curtRow = cellInfo.node;
    const otherQtr = curtCol === 'startQtr' ? 'endQtr' : 'startQtr';
    const re_test = /[1-4]{1}[qQ]{1}\d{4}$/;
    const re_test2 = /[1-4]{1}[qQ]{1}\d{2}$/;

    if (curtRow.data) {
      let pass1 = false;
      let pass2 = false;
      if (
        (curtCol === 'endQtr' &&
          !_.isEmpty(newVal) &&
          _.isEmpty(curtRow?.data[otherQtr])) ||
        (curtCol === 'startQtr' &&
          _.isEmpty(newVal) &&
          !_.isEmpty(curtRow?.data.endQtr))
      ) {
        const passError = !_.isEmpty(errorField)
          ? _.filter(errorField, {
              ndc: curtRow?.data.ndc,
              errorType: 'startQtrRequired',
              listIndex: curtRow?.data.listIndex,
            })
          : [];
        if (_.isEmpty(passError)) {
          errorField.push({
            [curtCol]: true,
            field: curtCol,
            errorType: 'startQtrRequired',
            ndc: curtRow?.data.ndc,
            listIndex: curtRow?.data.listIndex,
            viewMessage: true,
            errorTitle: `For NDC ${curtRow?.data.ndc}`,
            message: `Start Quarter is required in Row ${
              cellInfo.rowIndex + 1
            }.`,
          });
        }
      } else {
        pass1 = true;
        indexOf = !_.isEmpty(errorField)
          ? _.findIndex(errorField, {
              ndc: curtRow?.data.ndc,
              errorType: 'startQtrRequired',
              listIndex: curtRow?.data.listIndex,
            })
          : null;
        if (!_.isNull(indexOf) && indexOf >= 0) {
          errorField.splice(indexOf, 1);
        }
      }
      if (
        !re_test.test(newVal) &&
        !re_test2.test(newVal) &&
        !_.isEmpty(newVal)
      ) {
        const passError = !_.isEmpty(errorField)
          ? _.filter(errorField, {
              field: curtCol,
              ndc: curtRow?.data.ndc,
              errorType: 'validQtrFormat',
              listIndex: curtRow?.data.listIndex,
            })
          : [];
        if (_.isEmpty(passError)) {
          errorField.push({
            [curtCol]: true,
            field: curtCol,
            errorType: 'validQtrFormat',
            ndc: curtRow?.data.ndc,
            listIndex: curtRow?.data.listIndex,
            viewMessage: true,
            errorTitle: `For NDC ${curtRow?.data.ndc}`,
            message: QUARTER_FORMAT_ERROR,
          });
        }
      } else {
        pass2 = true;
        indexOf = !_.isEmpty(errorField)
          ? _.findIndex(errorField, {
              field: curtCol,
              ndc: curtRow?.data.ndc,
              errorType: 'validQtrFormat',
              listIndex: curtRow?.data.listIndex,
            })
          : null;
        if (!_.isNull(indexOf) && indexOf >= 0) {
          errorField.splice(indexOf, 1);
        }
      }
      if (pass1 && pass2) {
        saveQtrChanges(curtRow, curtCol, value);
        if (!_.isEmpty(newVal)) {
          const qtrVal = getQtrVal(newVal);
          const pass = validateQtr(curtCol, qtrVal, curtRow?.data[otherQtr]);
          if (pass) {
            indexOf = !_.isEmpty(errorField)
              ? _.findIndex(errorField, {
                  ndc: curtRow?.data.ndc,
                  errorType: 'Validation',
                  listIndex: curtRow?.data.listIndex,
                })
              : null;
            if (!_.isNull(indexOf) && indexOf >= 0) {
              errorField.splice(indexOf, 1);
            }
          } else {
            const passError = !_.isEmpty(errorField)
              ? _.filter(errorField, {
                  ndc: curtRow?.data.ndc,
                  errorType: 'Validation',
                  listIndex: curtRow?.data.listIndex,
                })
              : [];
            if (_.isEmpty(passError)) {
              errorField.push({
                [curtCol]: true,
                field: curtCol,
                errorType: 'Validation',
                ndc: curtRow?.data.ndc,
                listIndex: curtRow?.data.listIndex,
                viewMessage: true,
                errorTitle: `For NDC ${curtRow?.data.ndc}`,
                message: END_QTR_ERROR,
              });
            }
          }
        }
      }
    }

    if (_.isEmpty(newVal) && _.isEmpty(curtRow?.data[otherQtr])) {
      indexOf = !_.isEmpty(errorField)
        ? _.findIndex(errorField, {
            field: curtCol,
            ndc: curtRow?.data.ndc,
            listIndex: curtRow?.data.listIndex,
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        errorField.splice(indexOf, 1);
      }
    }
    updateSetFieldErrors(errorField);
  };

  const frameworkComponents = {
    TextBoxRender: (cellInfo) => {
      // const errorData = !_.isEmpty(errorField)
      //   ? _.filter(
      //       errorField,
      //       (l) =>
      //         l.ndc === cellInfo.node?.data.ndc &&
      //         l.field === cellInfo.column.colId
      //     )
      //   : [];
      const errorData =
        (cellInfo.column.colId === 'startQtr' &&
          cellInfo.node?.data?.isErrorStartQtr) ||
        (cellInfo.column.colId === 'endQtr' &&
          cellInfo.node?.data?.isErrorEndQtr);
      return (
        <div className='form-wrapper vertical-wrapper qtr-input'>
          <TextField
            className={
              errorData
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
            }
            label={`excluded-ndcs-detail${cellInfo.rowIndex}${cellInfo.column.colId}`}
            fullWidth
            required
            placeholder=''
            inputProps={{
              minLength: 4,
              maxLength: 6,
              id: `excluded-ndcs-detail${cellInfo.rowIndex}${cellInfo.column.colId}`,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            onFocus={(e) => {
              setCurColumn(cellInfo.column.colId);
              setSelectRowData(cellInfo.node?.data);
              const agGridBody = e.currentTarget.closest('.ag-body-viewport');
              agGridBody
                .querySelectorAll('.ag-row-selected')
                .forEach((b) => b.classList.remove('ag-row-selected'));
              e.currentTarget
                .closest('.ag-row')
                .classList.add('ag-row-selected');
            }}
            onChange={(e) => {
              cellInfo.node.setDataValue(cellInfo.column.colId, e.target.value);
            }}
            onBlur={(e) => {
              const value = autoFormateDate(e?.target?.value.toUpperCase());
              cellInfo.node.setDataValue(cellInfo.column.colId, value);
              checkQtrValidation(cellInfo, value);
            }}
            value={cellInfo.value || null}
            id={`excluded-ndcs-detail${cellInfo.rowIndex}${cellInfo.column.colId}`}
            data-testid='excluded-ndcs-table-grid-textbox'
            disabled={!isEnablebyRole}
          />
        </div>
      );
    },
    IconButtonCell: (cellInfo) => {
      return (
        <div className='icon-btn-group'>
          <button variant='text' data-testid='excluded-ndcs-table-grid-comment'>
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='delete-tooltip'>Comment</Tooltip>}
            >
              {/* {corrLinkId ?<SVGComponent iconName="Icon-comment" /> : null} */}
              {cellInfo.node.data.corrLinkId !== null &&
              cellInfo.node.data.corrLinkId !== '' ? (
                <img
                  role='button'
                  alt='comment'
                  src={
                    cellInfo.node.data.ccCommentsExist === 1
                      ? CommentVisibleIcon
                      : CommentIcon
                  }
                  onClick={() => {
                    setShowComments(true);
                    setActionCellData(cellInfo.node.data);
                  }}
                  tabIndex={'0'}
                  onKeyDown={(e) => {
                    // Handle Enter and Space key events
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault(); // Prevents the default space scrolling behavior
                      setShowComments(true);
                      setActionCellData(cellInfo.node.data);
                    }
                  }}
                />
              ) : (
                <img alt='comment' src={CommentIcon} />
              )}
            </OverlayTrigger>
          </button>
          <Button
            className='frr-box-shadow-none'
            variant='text'
            aria-label='Delete'
            data-testid='excluded-ndcs-table-grid-delete'
            onClick={() => {
              setActionCellData(cellInfo.node.data);
              setDeleteModal(true);
            }}
            disabled={!isEnablebyRole}
          >
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
            >
              <SVGComponent iconName='Icon-delete' />
            </OverlayTrigger>
          </Button>
        </div>
      );
    },
    CheckboxCell: (cellInfo) => {
      const checkValidCheck = (curtCol, cellInfo1) => {
        if (cellInfo1.node?.data.excludedNdcStatusCd === 'Valid') {
          errorField.push({
            [curtCol]: true,
            field: curtCol,
            errorType: 'validCheckbox',
            ndc: cellInfo1.node?.data.ndc,
            listIndex: cellInfo1.node?.data.listIndex,
            viewMessage: true,
            errorTitle: `For NDC ${cellInfo1.node?.data.ndc}`,
            message: `NDC ${cellInfo1.node?.data.ndc} : A new record cannot be marked invalid`,
          });
        } else {
          const indexOf = !_.isEmpty(errorField)
            ? _.findIndex(errorField, {
                field: curtCol,
                ndc: cellInfo1.node?.data.ndc,
                errorType: 'validCheckbox',
                listIndex: cellInfo1.node?.data.listIndex,
              })
            : null;
          if (!_.isNull(indexOf) && indexOf >= 0) {
            errorField.splice(indexOf, 1);
          }
        }
        updateSetFieldErrors(errorField);
      };
      return (
        <div className='tbl-checkbox frr-checkbox-no-label'>
          <FormControlLabel

            control={<Checkbox color="primary" disabled={!isEnablebyRole} />}
            label={'exclude-checkbox'}

            onChange={(e) => {
              setEdit(true);
              checkValidCheck(cellInfo.column.colId, cellInfo);
              saveQtrChanges(
                cellInfo.node,
                cellInfo.column.colId,
                cellInfo.node?.data.excludedNdcStatusCd === 'Valid'
                  ? 'Invalid'
                  : 'Valid'
              );
              cellInfo.node.setDataValue(
                cellInfo.column.colId,
                cellInfo.node?.data.excludedNdcStatusCd === 'Valid'
                  ? 'Invalid'
                  : 'Valid'
              );
            }}
            checked={cellInfo.node?.data.excludedNdcStatusCd === 'Valid'}
            data-testid='excluded-ndcs-table-grid-checkbox'
            id='exclude-checkbox'
            disabled={!isEnablebyRole}
          />
        </div>
      );
    },
    DrugNameCell: (cellInfo) => {
      const name = cellInfo.data?.ndcName
        ? cellInfo.data?.ndcName
        : cellInfo.data?.drugName;

      if (name && name.length > 22) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name && `${name.substring(0, 22)}...`}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  const applyFiterAndSortAfterRender = React.useCallback(
    (params) => {
      if (applyFilterAndSort) {
        if (!_.isEmpty(filterAndSort) && tableName) {
          const filterData = filterAndSort[tableName]?.filter;
          const sortData = filterAndSort[tableName]?.sort;
          if (params?.api) {
            if (!_.isEmpty(filterData)) {
              params.api.setFilterModel(filterData);
            }
          }
          if (params?.columnApi) {
            if (!_.isEmpty(sortData)) {
              params.columnApi.applyColumnState({
                state: sortData,
                defaultState: { sort: null },
              });
            }
          }
        }
      }
    },
    [filterAndSort]
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const onGridReadyGrid = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setGridParams(params);
    applyFiterAndSortAfterRender(params);
    if (onGridReady) {
      onGridReady(params);
    }
  }, []);

  const onDeleteRow = (e) => {
    let deletedList = getNDCsList?.deletedList || [];
    allDeletedList.push(e);
    const newList = _.filter(
      getNDCsList?.updatedList,
      (l) => l.listIndex !== e?.listIndex
    );
    if (e?.excludedNdcSeqNum && !_.isNull(e?.excludedNdcSeqNum)) {
      setEdit(true);
      if (getNDCsList?.deletedList && !_.isEmpty(getNDCsList?.deletedList)) {
        deletedList = _.concat(getNDCsList?.deletedList, e);
      } else {
        deletedList = [e];
      }
    }
    setSuccessMessages([]);
    dispatch(
      saveExcludedNDCsDetailList({
        orgList: getNDCsList.orgList,
        updatedList: newList,
        deletedList: deletedList,
      })
    );
    setDeleteModal(false);
  };

  const updateFilterAndSort = (val) => {
    dispatch(
      setFilterAndSortForTable({
        ...filterAndSort,
        ...val,
      })
    );
  };

  const onSortChangedGrid = useCallback(
    (e) => {
      if (
        e.columnApi.getColumnState() &&
        Object.keys(e.columnApi.getColumnState()).length > 0
      ) {
        updateFilterAndSort({
          [tableName]: {
            ...filterAndSort[tableName],
            sort: e.columnApi.getColumnState(),
          },
        });
      }
    },
    [filterAndSort]
  );

  const onFilterChangedGrid = useCallback(
    (e) => {
      setTotalResultCount(e.api.getDisplayedRowCount());
      if (
        e.api.getFilterModel() &&
        Object.keys(e.api.getFilterModel()).length > 0
      ) {
        updateFilterAndSort({
          [tableName]: {
            ...filterAndSort[tableName],
            filter: e.api.getFilterModel(),
          },
        });
        setIsFilter(true);
        if (tableName && tableName === 'ndcLeft') {
          setIsFilterNDCs(true);
        }
        if (tableName && tableName === 'ndcRight') {
          setIsFilterRightNDCs(true);
        }
      } else {
        setIsFilter(false);
        if (tableName && tableName === 'ndcLeft') {
          setIsFilterNDCs(false);
        }
        if (tableName && tableName === 'ndcRight') {
          setIsFilterRightNDCs(false);
        }
      }
    },
    [filterAndSort]
  );

  const handleClearFilter = (tableName) => {
    gridRef.current.clearFilters();
    updateFilterAndSort({
      [tableName]: {
        ...filterAndSort[tableName],
        filter: [],
      },
    });
  };

  React.useEffect(() => {
    if (resetNDCsFilter && tableName && tableName === 'ndcLeft') {
      setResetNDCsFilter(false);
      handleClearFilter(tableName);
    }
    if (resetRightNDCsFilter && tableName && tableName === 'ndcRight') {
      setResetRightNDCsFilter(false);
      handleClearFilter(tableName);
    }
  }, [resetNDCsFilter, resetRightNDCsFilter]);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (!showComments && afterComment) {
      setLoading(true);
      const tempObj =
        getNDCsList.updatedList &&
        getNDCsList.updatedList?.map((item) => {
          if (
            item.corrLinkId === actionCellData?.corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === actionCellData?.corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      // setExcludedNDCs(tempObj);
      dispatch(
        saveExcludedNDCsDetailList({
          orgList: getNDCsList.orgList,
          updatedList: getNDCsList.updatedList,
          deletedList: getNDCsList.deletedList,
        })
      );
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    }
  }, [commentsList, showComments, afterComment]);

  React.useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    gridParams?.api.refreshCells();
  }, [data]);

  React.useEffect(() => {
    if (!_.isEmpty(selectRowData) && !_.isEmpty(data) && curColumn) {
      const rowIndex = data?.findIndex((x) => {
        return x.listIndex === selectRowData?.listIndex;
      });
      gridParams.api.ensureIndexVisible(rowIndex);
      gridParams.api.startEditingCell({
        rowIndex: rowIndex,
        colKey: `${curColumn}`,
      });
    }
  }, [data]);

  return (
    <div data-testid='excludedNDCs-table-grid-component' id='excludeNDC-table'>
      {tableHeader && (
        <div className='row top-header border-bottom'>
          <div className='col-6'>
            {fullScreenView && (
              <div className='full-view-page-title'>{fullScreenViewTable}</div>
            )}
          </div>
          <div className='col-6'>
            <div className='th-icon-group start-right'>
              {filterIcon && (
                <OverlayTrigger
                  placement='bottom'
                  overlay={
                    <Tooltip id='filter-tooltip'>Reset All Filters</Tooltip>
                  }
                >
                  {isFilter ? (
                    <a
                      className='th-icon ic-filter-activate'
                      data-testid='handleClearFilter'
                      onClick={() => handleClearFilter(tableName)}
                    >
                      <span className='ic-title'> Filter </span>
                    </a>
                  ) : (
                    <a className='th-icon ic-filter'>
                      <span className='ic-title'> Filter </span>
                    </a>
                  )}
                </OverlayTrigger>
              )}

              {historyIcon && (
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id='history-tooltip'>View History</Tooltip>}
                >
                  <a
                    className='th-icon ic-history'
                    onClick={handleViewHistoryPlan}
                    tabIndex='0'
                  >
                    <span className='ic-title'> History </span>
                  </a>
                </OverlayTrigger>
              )}

              {actionIcon && (
                <div className='th-icon ic-actions'>
                  <PDFExportPanel
                    gridApi={gridApi}
                    columnApi={columnApi}
                    fileName='Excluded NDCs'
                    childRef={gridRef}
                    addRowsView={addRowsView}
                    addRowsTitle='Add NDC Exclusion'
                    onClickAddNdC={addNDCsAction}
                    isEnablebyRole={isEnablebyRole}
                  />
                </div>
              )}

              {fullScreenIcon && (
                <OverlayTrigger
                  placement='bottom'
                  overlay={
                    <Tooltip id='fullScreen-tooltip'>
                      {!fullScreenView ? 'Full Screen' : 'Exit Full Screen'}
                    </Tooltip>
                  }
                >
                  <div
                    className={clsx(
                      'th-icon',
                      fullScreenView ? 'ic-fulScreen-exit' : 'ic-fulScreen'
                    )}
                    onClick={setFullScreenView}
                    data-testid='full-screen-action-btn'
                    tabIndex='0'
                  >
                    <span className='ic-title'> Full Screen </span>
                  </div>
                </OverlayTrigger>
              )}
            </div>
          </div>
        </div>
      )}

      <TableGrid
        onGridReady={onGridReadyGrid}
        ref={gridRef}
        onSelect={onSelect}
        rowSelection={rowSelection || 'single'}
        rowMultiSelectWithClick={rowMultiSelectWithClick || false}
        rowData={data}
        suppressMenuHide
        columnDefs={cellHead}
        gridHeight={gridHeight}
        animateRows
        sideBar
        childPopup={childPopup || false}
        domLayout='autoHeight'
        frameworkComponents={frameworkComponents}
        onCellValueChanged={onCellValueChanged}
        singleClickEdit={singleClickEdit || false}
        suppressNavigation={suppressNavigation}
        onFilterChanged={onFilterChangedGrid}
        onSortChanged={onSortChangedGrid}
        data-testid='excluded-ndcs-table-grid'
        setTotal={setTotalResultCount}
        fileName={fileName}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        enterMovesDown
        suppressCellFocus
        columnList={columnList}
        columnAction={columnAction}
        pinnedColumnList={pinnedColumnList}
        columnPinnedAction={columnPinnedAction}
        onCellFocused={onCellFocused}
      />

      {deleteModal && (
        <CommonModal
          className='frr-dialog-css dialog-420'
          open={deleteModal}
          viewAction
          viewHeader
          onOk={() => onDeleteRow(actionCellData)}
          okTitle='Yes'
          onClose={() => setDeleteModal(false)}
          closeTitle='No'
          modalTitle={`Delete NDC ${actionCellData?.ndc}`}
          childrenComponent={`Are you sure you want to Delete the selected row ndc ${actionCellData?.ndc}?`}
        />
      )}

      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={(e) => {
            setShowComments(e);
            setAfterComment(true);
          }}
          linkTableName='EXCLUDED_NDC'
          corrLinkId={actionCellData && actionCellData.corrLinkId}
        />
      ) : null}
    </div>
  );
}

export default TableGridComponent;
